import { Schema } from "effect";
import { ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { QueueSnapshot } from "@workerstation/shared/resources/object-queue";
export type QueueRecord = typeof QueueSnapshot.Type.queues[number];
export type QueueMessage = QueueRecord["messages"][number];
export const QueueTarget = Schema.Struct({ workspaceId: Schema.String, queueName: Schema.String });
export type QueueTarget = typeof QueueTarget.Type;
export const PreparedQueueTarget = Schema.Struct({ workspaceId: ResourceWorkspaceId, queueName: Schema.String.pipe(Schema.brand("FrontendQueueName")) });
export const PreparedMessageId = Schema.String.pipe(Schema.brand("FrontendQueueMessageId"));
